import type { NavigationEditorItem } from './navigationEditorTypes'

export function findEditorItemById(
  items: NavigationEditorItem[],
  id: string,
): NavigationEditorItem | null {
  for (const item of items) {
    if (item.id === id) return item
    if (item.children?.length) {
      const found = findEditorItemById(item.children, id)
      if (found) return found
    }
  }

  return null
}

function findItemParentAndIndex(
  items: NavigationEditorItem[],
  id: string,
  parentId: string | null = null,
): { parentId: string | null; index: number } | null {
  for (let index = 0; index < items.length; index++) {
    const item = items[index]
    if (!item) continue
    if (item.id === id) {
      return { parentId, index }
    }

    if (item.children?.length) {
      const found = findItemParentAndIndex(item.children, id, item.id)
      if (found) return found
    }
  }

  return null
}

export function canCreateNestUnderLink(
  items: NavigationEditorItem[],
  anchorId: string,
  dragId: string,
): boolean {
  if (anchorId === dragId) return false

  const anchor = findEditorItemById(items, anchorId)
  const dragged = findEditorItemById(items, dragId)
  if (!anchor || !dragged) return false
  if (anchor.kind !== 'link') return false
  if (dragged.kind === 'section') return false

  const anchorLocation = findItemParentAndIndex(items, anchorId)
  if (!anchorLocation?.parentId) return false

  const parent = findEditorItemById(items, anchorLocation.parentId)
  if (!parent) return false
  if (parent.kind === 'section' || parent.kind === 'group') return true

  return false
}

export function shouldCreateNewNestGroupUnderLink(
  items: NavigationEditorItem[],
  anchorId: string,
  dragId: string,
): boolean {
  if (!canCreateNestUnderLink(items, anchorId, dragId)) return false

  const anchorLocation = findItemParentAndIndex(items, anchorId)
  if (!anchorLocation?.parentId) return false

  const parent = findEditorItemById(items, anchorLocation.parentId)
  return parent?.kind === 'section'
}

export function getExistingNestGroupIdForLinkAnchor(
  items: NavigationEditorItem[],
  anchorId: string,
): string | null {
  const anchorLocation = findItemParentAndIndex(items, anchorId)
  if (!anchorLocation?.parentId) return null

  const parent = findEditorItemById(items, anchorLocation.parentId)
  if (!parent || parent.kind !== 'group') return null

  return parent.id
}
